import React from 'react'
import {
    Box,
    Divider,
    Text,
    Heading,
    Image
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

const EngravingPurchasePath = (props) => {
    const {
        engravingImages,
        highlightTitle,
        highlightDescription,
        onOpen,
        tagManager,
        setEngravingImages,
        setDesktopGalleryEngImages,
        onClose,
        setDriveRecipeID,
        setOpenEngraving,
        navigate
    } = props

    return (
        <>
            <Box display="grid" gap="5px">
                <Heading
                    as="h2"
                    color="black"
                    fontSize="24px"
                    fontWeight="500"
                    fontFamily="caslon"
                    letterSpacing="0.12px"
                    lineHeight="normal"
                >
                    {engravingImages.face1?.image || engravingImages.face2?.image ? (
                        <FormattedMessage
                            id="engraving.title.added"
                            defaultMessage="Engraving Added"
                        />
                    ) : (
                        highlightTitle || (
                            <FormattedMessage
                                id="engraving.title"
                                defaultMessage="Complimentary Engraving"
                            />
                        )
                    )}
                </Heading>
                <Text
                    color="black.300"
                    fontSize="13px"
                    letterSpacing="0.065px"
                    fontWeight="300"
                    display={
                        engravingImages.face1?.image || engravingImages.face2?.image
                            ? 'none'
                            : 'block'
                    }
                >
                    {highlightDescription || (
                        <FormattedMessage
                            id="engraving.description"
                            defaultMessage="Personalize this piece with a combination of text, symbols and zodiac signs."
                        />
                    )}
                </Text>
            </Box>
            {!engravingImages.face1?.image && !engravingImages.face2?.image && (
                <Box
                    display="inline-flex"
                    marginTop="20px"
                    width="fit-content"
                    padding="4px 25px"
                    borderRadius="90px"
                    backgroundColor="teal.500"
                    transition="backgroundColor, 0.3s ease"
                    cursor="pointer"
                    _hover={{
                        backgroundColor: 'teal.400'
                    }}
                >
                    <Text
                        color="gray.200"
                        letterSpacing="0.07px"
                        fonWeight="400"
                        lineHeight="22px"
                        fontSize="14px"
                        cursor="pointer"
                        onClick={() => {
                            onOpen()
                            tagManager.openEngravingModal()
                        }}
                    >
                        <FormattedMessage id="customize.engraving" defaultMessage="Customize" />
                    </Text>
                </Box>
            )}
            <Box
                className="engraved-images"
                display={
                    engravingImages.face1?.image || engravingImages.face2?.image
                        ? 'inline-flex'
                        : 'none'
                }
                gap="20px"
                width="fit-content"
                marginTop="10px"
            >
                {engravingImages.face1?.image && (
                    <Box className="engraved-img-1">
                        <Image
                            width="70px"
                            height="88px"
                            marginBottom="5px"
                            alt="Engraved Image"
                            src={engravingImages.face1.image}
                        />
                        {engravingImages.face1.name && (
                            <Text color="black" fontSize="16px" fontWeight="300" textAlign="center">
                                {engravingImages.face1.name}
                            </Text>
                        )}
                    </Box>
                )}
                {engravingImages.face2?.image && (
                    <Box className="engraved-img-2">
                        <Image
                            width="70px"
                            height="88px"
                            marginBottom="5px"
                            alt="Engraved Image"
                            src={engravingImages.face2.image}
                        />
                        {engravingImages.face2.name && (
                            <Text color="black" fontSize="16px" fontWeight="300" textAlign="center">
                                {engravingImages.face2.name}
                            </Text>
                        )}
                    </Box>
                )}
                {(engravingImages.face1?.image || engravingImages.face2?.image) && (
                    <Box
                        gap="20px"
                        display={
                            engravingImages.face1?.image && engravingImages.face2?.image
                                ? 'grid'
                                : 'inline-flex'
                        }
                        margin={
                            engravingImages.face1?.image && engravingImages.face2?.image
                                ? 'unset'
                                : '31px auto'
                        }
                        alignContent="center"
                    >
                        <Text
                            cursor="pointer"
                            color="teal.500"
                            fontWeight="300"
                            fontSize="16px"
                            letterSpacing="0.08px"
                            lineHeight="25px"
                            textDecoration="underline"
                            textUnderlineOffset="4px"
                            height="fit-content"
                            onClick={() => {
                                onOpen()
                                tagManager.openEngravingModal()
                            }}
                            _hover={{
                                color: 'teal.600'
                            }}
                        >
                            <FormattedMessage id="edit.free.engraving" defaultMessage="Edit" />
                        </Text>
                        {(!engravingImages.face1?.image || !engravingImages.face2?.image) && (
                            <Divider
                                orientation="vertical"
                                height="30px"
                                borderColor="gray.400"
                                marginLeft="0px"
                                marginRight="0px"
                            />
                        )}
                        <Text
                            cursor="pointer"
                            color="black.300"
                            fontWeight="300"
                            fontSize="16px"
                            letterSpacing="0.08px"
                            lineHeight="25px"
                            textDecoration="underline"
                            textUnderlineOffset="4px"
                            height="fit-content"
                            _hover={{
                                color: 'teal.600'
                            }}
                            onClick={() => {
                                setEngravingImages({
                                    face1: null,
                                    face2: null
                                })
                                setDesktopGalleryEngImages(null)
                                onClose()
                                setDriveRecipeID('')
                                setOpenEngraving(false)
                                navigate(location.pathname) // This was added as per YR-1148. "Clears engraving and resets the PDP view to default (non-engraved state)."
                            }}
                        >
                            <FormattedMessage
                                id="remove.engraving"
                                defaultMessage="Remove Engraving"
                            />
                        </Text>
                    </Box>
                )}
            </Box>
        </>
    )
}

EngravingPurchasePath.propTypes = {
    engravingImages: PropTypes.shape({
        face1: PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string
        }),
        face2: PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string
        })
    }),
    highlightTitle: PropTypes.string,
    highlightDescription: PropTypes.string,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    setEngravingImages: PropTypes.func,
    setDesktopGalleryEngImages: PropTypes.func,
    setDriveRecipeID: PropTypes.func,
    setOpenEngraving: PropTypes.func,
    navigate: PropTypes.func,
    tagManager: PropTypes.shape({
        openEngravingModal: PropTypes.func,
        saveEngraving: PropTypes.func,
        doNotEngrave: PropTypes.func,
        addToCart: PropTypes.func
    })
}

export default EngravingPurchasePath
